
import { useDispatch, useSelector } from 'react-redux';
import { useContext } from 'react';
import {


  selectMCIsExpanded,


} from 'shared/slice/MCIsExpandedSlice';

import {

  essSpecificLocationUnselectMachinesHandler,




  handleOpenMachineController,




  handleUnSelectIndividualMachine,

  selectEssSwitch,
} from 'shared/slice/essSwitchSlice';

import { useMediaQuery } from 'react-responsive';

import styled from 'styled-components';

import MasterControlBySwitch from 'shared/components/commonComponentsMC/MasterControlBySwitch';
import IntegratedSwitchLocations from 'shared/components/commonComponentsMC/IntegratedSwitchLocations';
import {
  handleResetAllSelectBySwitch,

} from 'shared/slice/masterControlBySwitchSelectSlice';
import {
  handleResetAllSelectByLocation,

} from 'shared/slice/masterControlSelectByLocationSlice';
import { selectUnits } from 'shared/slice/unitsSlice';
import {
  useGetScheduleQueries,
  useGetThermocouplesQueries,
  useSetZoneOpeningsState,
} from 'shared/hooks';
import {

  getEssZones,


} from 'shared/services';





import { useQuery } from 'react-query';
import { handleAccessToken } from 'shared/slice/userSlice';
import { selectUserPermissions } from "shared/slice/userSlice";


import {

  loopMachinesHandler,
} from 'shared/helpers/ess-tgs-tes-mc';
import { filterZonesWithDevices } from 'shared/helpers/locationsCache';
import { EssTgsTesContext } from 'shared/context/contextOfEssTgsTes';
import { useSetOpenMasterControl } from 'shared/hooks/ess_tgs_tes_hooks/useSetOpenMasterControl';

const EssMain = ({ isMasterControl }) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });


  const { essSwitch,flatEssSwitch } = useSelector(selectEssSwitch);


  const MCIsExpanded = useSelector(selectMCIsExpanded);
  const { masterControl } = MCIsExpanded.ess;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;


  const { messageBoxHandler } = useContext(EssTgsTesContext);







  const dispatch = useDispatch();

  useGetScheduleQueries(flatEssSwitch, 'ESS');
  useGetThermocouplesQueries(flatEssSwitch, 'ess');


  useSetOpenMasterControl('ess', isMobile);

  useSetZoneOpeningsState(
    flatEssSwitch,
    masterControl,
    handleOpenMachineController,
    'ess'
  );

  const { data: essZones } = useQuery(
    ['essZones', 'structured'],
    () => getEssZones({ structured: true }).then(filterZonesWithDevices),
    {
      enabled: !!handleAccessToken,
      staleTime: Infinity,
    }
  );

  const permissions = useSelector(selectUserPermissions);

  const integratedButtonHandler = (
    id,
    state,
    scope,
    temp,
    data,
    type,
    specificLocation
  ) => {

    if(permissions.WRITE){
    loopMachinesHandler(
      id,
      state,
      scope,
      type,
      temp,
      data,
      isF,
      essZones,
      'ESS',
      flatEssSwitch,
      dispatch,
      handleUnSelectIndividualMachine,
      essSpecificLocationUnselectMachinesHandler,
      handleResetAllSelectBySwitch,
      handleResetAllSelectByLocation,
      messageBoxHandler,
      essSwitch,
    );
  }

  };

  return (
    <Wrapper>
      {isMasterControl || (
        <Section>
          <MasterControlBySwitch
            swtName='ess'
            buttonHandler={integratedButtonHandler}
          />
        </Section>
      )}

      <Section>
        <IntegratedSwitchLocations
          swtName='ess'
          buttonHandler={integratedButtonHandler}
        />
      </Section>
    </Wrapper>
  );
};

export default EssMain;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.section`
  &:first-child {
    margin-bottom: 8px;
  }
`;
